//------------- AGENDA ---------

//esta página tambem serve como wrapper das páginas:
// - Rotas
// - Tecnicos

//nessa página será necessário que o usuário clique e arraste uma rota até algum dos slots
//do calendário, assim quando clicando no botão salvar (ainda não feito), cadastrará uma nova
//agenda no banco, referenciado ao técnico selecionado

//será necessário também, botões para copiar a as tarefas da semana anterior para a semana atual
//e caso possivel, um botão para copiar as tarefas do mês passado para o mês atual

//pensei em colocar esses 3 botões citados anteriormente na parte inferior direita do calendario
//mas não tive certeza

//apague esses comentarios quando terminar as tarefas kkkkkk

//importações
import React from "react";
import { useState, useEffect } from "react";
import "./styles.css";
import { Link } from "react-router-dom";

//icons
import { BiRefresh } from "react-icons/bi";
import { FaRegEye } from "react-icons/fa";
import { BsPlus } from "react-icons/bs";
import { FiArrowLeft, FiChevronUp } from "react-icons/fi";
import { FiChevronDown } from "react-icons/fi";

import handleProfilePic from "../../utils/functions/profilePic";

//components
import MenuNavigator from "../../components/menu-navigator";
import Rotas from "../Rotas";
import Tecnicos from "../Tecnicos";
import RoundedButton from "../../components/btn-rounded";
import InputSearch from "../../components/inpt-search";
import Requests from "../../services/requests";
import Calendario from "../../components/agenda-calendar";

const Popups = ({ conteudo }) => {
	return (
		<div
			style={{
				position: "fixed",
				top: 0,
				left: "3%",
				width: "100%",
				height: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				backgroundColor: "rgba(0,0,0,0.6)",
				boxSizing: "border-box",
				zIndex: 1000000,
			}}
		>
			<div
				style={{
					boxSizing: "border-box",
					padding: 40,
					borderRadius: 40,
					backgroundColor: "white",
				}}
			>
				{conteudo}
			</div>
		</div>
	);
};

const AgendaPopup = ({ setPopup, rotaAgenda, changeAgenda, deleteAgenda }) => {
	let dataInicial = new Date(rotaAgenda.datahora_inicio);
	let dataFinal = new Date(rotaAgenda.datahora_fim);

	const defaultIniH = dataInicial.getHours().toString().padStart(2, "0");
	const defaultIniM = dataInicial.getMinutes().toString().padStart(2, "0");
	const defaultIni = `${defaultIniH}:${defaultIniM}`;

	const defaultFinH = dataFinal.getHours().toString().padStart(2, "0");
	const defaultFinM = dataFinal.getMinutes().toString().padStart(2, "0");
	const defaultFin = `${defaultFinH}:${defaultFinM}`;

	const [inputInicial, setInputInicial] = useState(defaultIni);
	const [inputFinal, setInputFinal] = useState(defaultFin);

	const submitForm = (e) => {
		e.preventDefault();

		if (inputInicial && inputFinal) {
			if (inputFinal > inputInicial) {
				let sInputI = inputInicial.split(":");
				let sInputF = inputFinal.split(":");

				dataInicial.setHours(sInputI[0], sInputI[1], 0, 0);
				dataFinal.setHours(sInputF[0], sInputF[1], 0, 0);

				changeAgenda(rotaAgenda.id, dataInicial, dataFinal);

				setPopup();
			} else {
				alert("O horário final precisa ser maior do que o horário inicial.");
			}
		} else {
			alert("Os campos precisam ser preenchidos.");
		}
	};

	return (
		<div>
			<button
				onClick={() => {
					setPopup();
				}}
				className="popupComponentVoltar"
			>
				<FiArrowLeft /> Voltar
			</button>

			<form onSubmit={submitForm} className="popupFormComponent">
				<h3 className="popupTitleComponent">{rotaAgenda.rota}</h3>

				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-around",
						gap: 10,
					}}
				>
					<label>
						<div>Horário inicial</div>
						<input
							type={"time"}
							value={inputInicial}
							onChange={(e) => {
								setInputInicial(e.target.value);
							}}
						/>
					</label>
					<label>
						<div>Horário final</div>
						<input
							type={"time"}
							value={inputFinal}
							onChange={(e) => {
								setInputFinal(e.target.value);
							}}
						/>
					</label>
				</div>

				<div
					style={{
						display: "flex",
						alignItems: "stretch",
						justifyContent: "space-around",
						gap: 10,
						marginTop: 20,
					}}
				>
					<button
						style={{
							flex: 1,
						}}
						onClick={() => {
							deleteAgenda(rotaAgenda.id);
							setPopup();
						}}
					>
						Remover da agenda
					</button>
					<button
						style={{
							flex: 1,
						}}
						type="submit"
					>
						Salvar Alterações
					</button>
				</div>
			</form>
		</div>
	);
};

//component
const Agenda = ({ token, popup = null }) => {
	//verifica se alguma das outras páginas (de form) estão sendo exibidas
	const [popupContent, setPopupContent] = useState(popup);
	const [popup2, setPopup2] = useState();

	const [loading, setLoading] = useState(false); //animação de loading

	const [search, setSearch] = useState(""); //barra de pesquisa de tag de rotas

	const [agenda, setAgenda] = useState([]);
	const [observaRota, setObservaRota] = useState([]);

	const [page, setPage] = useState(0); //pagina de tag de rotas atual
	const [rotas, setRotas] = useState([]); //conjunto de rotas mutável
	const [rotasAll, setRotasAll] = useState([]); //conjunto de todas as rotas
	const [rotasPage, setRotasPage] = useState([]); //rotas da página atual
	const limit = 7; //limite de rotas por pagina

	//técnico selecionado atualmente
	const [selectedTec, setSelectedTec] = useState({});
	const [selectedRota, setSelectedRota] = useState();

	//botão bolinha estilizado
	const StyledBtn = ({ icon, stl, text, event }) => {
		const [onhover, setonhover] = useState(false);
		if (typeof event === "string") {
			return (
				<Link
					to={event}
					onMouseOver={() => {
						setonhover(true);
					}}
					onMouseOut={() => {
						setonhover(false);
					}}
					className={stl}
				>
					{onhover ? text : icon}
				</Link>
			);
		} else {
			return (
				<div
					onClick={event}
					onMouseOver={() => {
						setonhover(true);
					}}
					onMouseOut={() => {
						setonhover(false);
					}}
					className={stl}
				>
					{onhover ? text : icon}
				</div>
			);
		}
	};

	//verifica se o botão avançar e voltar página estão habilitados
	//conforme a página atual e as páginas seguintes
	const handlePageAble = (button) => {
		switch (button) {
			case "left":
				if (page === 0) {
					return false;
				} else {
					return true;
				}
			case "right":
				if (page < rotas.length / limit - 1) {
					return true;
				} else {
					return false;
				}

			default:
				break;
		}
	};

	//carrega as rotas do banco
	const getRotas = () => {
		let parametros = {
			id_usuario: selectedTec.id,
		};
		let config = { headers: { "x-access-token": token } };
		if (selectedTec.id) {
			Requests.getRotas(config)
				.then((res) => {
					if (res) {
						let content = res.sort((a, b) => {
							return a.nome.localeCompare(b.nome);
						});
						//lógica que gerencia as páginas do dgrid
						let startContent = [];
						for (let i = limit * page; i < limit * page + limit; i++) {
							if (res[i]) {
								startContent.push(res[i]);
							}
						}
						//setta os states com o resultado da request
						setRotas(content);
						setRotasAll(content);
						setRotasPage(startContent);
						setPage(0);
					}
				})
				.catch((res, err) => {
					console.log(res, err);
				});
		}
	};

	//gerencia a troca de página
	const handleChangePage = (r = rotas) => {
		let actualRotas = [];
		for (let i = limit * page; i < limit * page + limit; i++) {
			if (r[i]) {
				actualRotas.push(r[i]);
			}
		}
		setRotasPage(actualRotas);
	};

	//gerencia a barra de pesquisa
	const handleSearch = () => {
		let filtered;
		filtered = rotasAll.filter((a) => {
			return a.nome.toLowerCase().includes(search.toLocaleLowerCase());
		});
		setRotas(filtered);
		handleChangePage(filtered);
	};

	//watcher da barra de pesquisa, para não bugar o loadcontent da página
	useEffect(() => {
		if (search) {
			handleChangePage(rotas);
		} else {
			handleChangePage();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page, rotas]);

	//gerencia a abertura de alguma página de form
	useEffect(() => {
		setPopupContent(popup);
	}, [popup]);

	//insira aqui as páginas de forms para abrirem como "popup" na página Agenda
	const handlePopupContent = () => {
		switch (popupContent) {
			case "rotas":
				return (
					<Rotas
						token={token}
						id_usuario={selectedTec.id}
						setRotas={setRotas}
						observaRota={observaRota}
						setObservaRota={setObservaRota}
					/>
				);
			case "tecnicos":
				return <Tecnicos setSelectedTec={setSelectedTec} token={token} />;
			default:
				setPopupContent(null);
				break;
		}
	};

	const updateAgenda = () => {
		let parametros = {
			id_usuario: selectedTec.id,
		};
		let config = { headers: { "x-access-token": token } };
		Requests.getAgenda(parametros, config).then((res) => {
			setAgenda(res);
		});
	};

	const dropAgenda = (dt) => {
		if (selectedRota) {
			let parametros = {
				id_usuario: selectedTec.id,
				id_rota: selectedRota.id,
				datahora_inicio: dt,
			};
			let config = { headers: { "x-access-token": token } };
			Requests.agendarRota(parametros, config).then((res) => {
				if (Array.isArray(res)) setAgenda(res);
				else {
					alert("Erro inesperado");
				}
			});
		} else {
			alert("Erro inesperado");
		}
	};

	const changeAgenda = (idRota, dtInicio, dtFim) => {
		let parametros = {
			id_usuario: selectedTec.id,
			id_agenda: idRota,
			datahora_inicio: dtInicio,
			datahora_fim: dtFim,
		};
		let config = { headers: { "x-access-token": token } };
		Requests.changeAgenda(parametros, config).then((res) => {
			if (Array.isArray(res)) setAgenda(res);
			else {
				alert("Erro inesperado");
			}
		});
	};

	const deleteAgenda = (id) => {
		let parametros = {
			id_agenda: id,
			id_usuario: selectedTec.id,
		};
		let config = { headers: { "x-access-token": token } };
		Requests.deleteAgenda(parametros, config)
			.then((res) => {
				if (Array.isArray(res)) setAgenda(res);
				else {
					alert("Erro inesperado");
				}
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const changeAgendaPopup = (rotaAgenda) => {
		setPopup2(
			<Popups
				conteudo={
					<AgendaPopup
						setPopup={setPopup2}
						rotaAgenda={rotaAgenda}
						changeAgenda={changeAgenda}
						deleteAgenda={deleteAgenda}
					/>
				}
			/>
		);
	};

	useEffect(() => {
		if (!isNaN(selectedTec.id)) {
			updateAgenda();
			getRotas();
		} else {
			setAgenda();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedTec]);

	useEffect(() => {
		setLoading(true);
		getRotas();
		setTimeout(() => {
			setLoading(false);
		}, 200);
	}, [observaRota]);

	//VIEW DA PÁGINA
	const handleViewComponent = () => {
		return (
			<div className="div-body-agenda-component">
				<div className="agenda-conteudo" style={{ position: "relative" }}>
					<div className="agenda-header">
						<div>
							{/* verifica se algum técnico foi selecionado
                            caso tenha sido, retorna o "perfil" do técnico,
                            caso não, solicita a abertura de um técnico */}
							{selectedTec.id ? (
								<div>
								<fieldset>
									<legend>Agenda do técnico</legend>
									<div className="agenda-profile-div">
										<div id="pic">
											<p>{handleProfilePic(selectedTec)}</p>
										</div>
										<div id="nome">
											<p className="nome">
												{selectedTec.nome ? selectedTec.nome : "nome"}
											</p>
											<p className="tipo">
												{selectedTec.tipo ? selectedTec.tipo : "tipo"}
											</p>
										</div>
									</div>
									<div id="view">
										<FaRegEye></FaRegEye>
									</div>
									<div id="select">
										<RoundedButton
											type={"link"}
											event={"/agenda/tecnicos"}
											text={"Alterar técnico"}
										></RoundedButton>
									</div>
								</fieldset>
								<div>
									<div class="color-legend">
										<div class="color-circle color-red"></div>
										<p class="text-legend"> Rota não realizada.</p>
									</div>
									<div class="color-legend">
										<div class="color-circle color-green"></div>
										<p class="text-legend"> Rota realizada na hora correta.</p>
									</div>
									<div class="color-legend">
										<div class="color-circle color-yellow"></div>
										<p class="text-legend"> Rota realizada na hora incorreta.</p>
									</div>
									<div class="color-legend">
										<div class="color-circle color-gray"></div>
										<p class="text-legend"> Rota não realizada e justificada.</p>
									</div>
									</div>
								</div>
							) : (
								<fieldset>
									<legend>Agenda do técnico</legend>
									<div className="agenda-profile-div">
										<div id="nome">
											<p>Nenhum técnico selecionado</p>
										</div>
									</div>
									<div id="select">
										<RoundedButton
											type={"link"}
											event={"/agenda/tecnicos"}
											text={"Escolher técnico"}
										></RoundedButton>
									</div>
								</fieldset>
							)}
						</div>
						{/* div que exibe as tags das rotas, a barra de pesquisa                        
                        e os botões de cadastrar rota e recarregar a pagina */}
						{/* exibe também as tags das rotas */}
						{!isNaN(selectedTec.id) ? (
							<div>
								<div>
									{/* pesquisa */}
									<InputSearch
										handleSearch={handleSearch}
										search={search}
										setSearch={setSearch}
										placeholder="Rotas..."
									></InputSearch>
									{/* botão criar rota */}
									{/* <StyledBtn
										event={"/agenda/rotas"}
										text={"criar rota"}
										icon={<BsPlus />}
										stl="btn-add"
									></StyledBtn> */}

									<Link className="btn-add-link" to={"/agenda/rotas"}>
										Criar Rota <BsPlus width={20} />
									</Link>
									{/* botão reload */}
									<StyledBtn
										event={() => {
											setLoading(true);
											getRotas();
											setTimeout(() => {
												setLoading(false);
											}, 200);
										}}
										text={"Recarregar"}
										icon={<BiRefresh />}
										stl="btn-add"
									></StyledBtn>
								</div>
								<div className="agenda-page-selector">
									{handlePageAble("left") ? (
										<FiChevronUp
											className="enable"
											onClick={() => {
												setLoading(true);
												setTimeout(() => {
													setPage(page - 1);
													setLoading(false);
												}, 200);
											}}
										/>
									) : (
										<FiChevronUp />
									)}
								</div>
								{!loading ? (
									<div id="agenda-list-rotas">
										{rotasPage.map((element, i) => {
											return (
												<div
													className="tag-rota"
													style={{
														backgroundColor: element.cor,
														cursor: "pointer",
													}}
													key={"rota-tag-" + i}
													draggable={true}
													onDragStart={() => {
														setSelectedRota(element);
													}}
													onDragEnd={() => {
														setSelectedRota();
													}}
												>
													<p style={{ margin: 0 }}>{element.nome}</p>
												</div>
											);
										})}
									</div>
								) : (
									<div className="refresh-page">
										<BiRefresh />
									</div>
								)}
								<div className="agenda-page-selector">
									{handlePageAble("right") ? (
										<FiChevronDown
											className="enable"
											onClick={() => {
												setLoading(true);
												setTimeout(() => {
													setPage(page + 1);
													setLoading(false);
												}, 200);
											}}
										/>
									) : (
										<FiChevronDown />
									)}
								</div>
							</div>
						) : (
							<div
								style={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
								}}
							>
								<Link id="escolha2" to={"/agenda/tecnicos"}>
									<p>SELECIONE UM TÉCNICO</p>
								</Link>
							</div>
						)}
					</div>
					{/* verifica se algum técnico foi selecionado
                    caso tenha sido, o calendário do técnico,
                    caso não, solicita a abertura de um técnico */}
					<div className="agenda-calendario">
						{selectedTec.id ? (
							<Calendario
								agenda={agenda}
								dropAgenda={dropAgenda}
								changeAgenda={changeAgendaPopup}
							></Calendario>
						) : (
							<Link id="escolha" to={"/agenda/tecnicos"}>
								<p>SELECIONE UM TÉCNICO</p>
							</Link>
						)}
					</div>
					{popup2}
				</div>
				{/* verifica se algum popup de formulário foi aberto */}
				{popupContent !== null && (
					<div className="bg-popup" style={{ zIndex: 10000 }}>
						{handlePopupContent()}
					</div>
				)}
			</div>
		);
	};

	//ENVIA A VIEW DA PÁGINA PARA O COMPONENT NAVIGATOR
	return (
		<MenuNavigator
			token={token}
			page={"/agenda"}
			view={handleViewComponent()}
		></MenuNavigator>
	);
};

export default Agenda;
